export default __webpack_public_path__ + "static/media/snake_eater.f634e186.jpg";